import styled from 'styled-components';

export const TrackingContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  background-color: transparent; /* Fundo transparente para mesclar com a página */
`;

export const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 10px;

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.35rem;
  font-family: 'Inter', sans-serif;
`;

export const Th = styled.th`
  position: sticky;
  top: 0;
  height: 2.2rem;
  background-color: #f5f5f5;
  z-index: 10;

  text-align: left;
  padding: 0 1.2rem;
  font-size: 0.85rem;
  font-weight: 400;
  color: #696969;
  border: 0;
  white-space: nowrap;
  cursor: default;
`;

export const TableRow = styled.tr`
  height: 2.4rem;
  background-color: #fff;
  border-bottom: solid 1px #ebebeb;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f7f7f7;
  }
`;

export const Td = styled.td`
  text-align: start;
  font-size: 12px;
  padding-left: 1.2rem;
  color: #303030;
  background-color: #fff;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  &:last-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
`;

export const StatusText = styled.span`
  font-size: 12px;
  color: #303030;
  font-weight: 400;
`;

export const IconCellButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  margin-top: auto;
  width: 100%;
`;

export const EmptyStateRow = styled.tr`
  td {
    text-align: center;
    padding: 20px;
    color: #696969;
    font-size: 12px;
    background-color: #fff;
  }
`;
export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 18px;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;